import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { useSelector } from 'react-redux';

import axios from "axios";
import { saveAs } from "file-saver";

import { downloadOutsourcingFile, outsourcingContractCall, uncontractCall } from "../../crud/auth.crud"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import loading from "../../assets/images/loading.gif";
import Pagination from "pages/Custom/Pagination";
import Loading from "pages/Custom/Loading";

const OutsourcingUncontracted = ({ getListLength, searchState, searchCondition }) => {

  const history = useHistory()

  // 드롭다운
  const [settingMenu, setSettingMenu] = useState(false)

  // useState가 list일 땐 목록창, detail일 땐 디테일창, modify일 땐 수정창
  const [form, setForm] = useState('list')

  // contractDataList 객체 추출용
  const [detailData, setDetailData] = useState({})

  const selector = useSelector(state => state);

  const [page, setPage] = useState(1)
  const [dataList, setDataList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
  const [refresh, setRefresh] = useState(false)
  
  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;        
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;        
      if (scrollPosition >= scrollHeight - 1) {          
        setPage(page + 1)
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])

  const getContract = async () => {
    if (isLoading || isListEnd)
      return
    setIsLoading(true)
    const params = {
      company: selector.auth?.user?.member_group?.[0]?.company_group.id,
      company_to: searchCondition.companyName || '',
      state: 'Y',
      page: page
    }
    const rs = await outsourcingContractCall(params)
    getListLength(rs.data.count)
    const content = rs.data?.results?.data || []
    const newList = [...dataList, ...content]
    if (page === 1) {
      setDataList(content)
    } else {
      setDataList([...dataList, ...content])
    }
    if (newList.length >= rs.data.count) {
      setIsListEnd(true)
    }
    setIsLoading(false)
    setRefresh(false)
  }

  const fileDownload = async (id) => {
    const response = await downloadOutsourcingFile({ id: id })
    const item = response.data.files
    if (item.length === 0) {
      return alert('다운로드할 파일이 없습니다.')
    }
    for (let i = 0; i < item.length; i++) {
      let url = "wasteverse.ropiklabs.com" + item[i].path
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const imgUrl = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = imgUrl;
          if (item[i].path.indexOf('.pdf') === -1) {
            link.setAttribute('download', '계약서.png');
          } else {
            link.setAttribute('download', '계약서.pdf');
          }
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error('에러내용 >>> ', error)
        })
    }
  };

  useEffect(() => {
    if (refresh)
      getContract()
  }, [refresh])

  useEffect(() => {
    if (!isListEnd)
      setRefresh(true)
  }, [page, isListEnd])

  useEffect(() => {
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
    setIsListEnd(false)
  }, [searchState])

  const clickList = (item) => {
    setDetailData({ ...item });
    const url = {
      pathname: `/outsourcing-contract-management-screen-detail`,
      state: { ...item }
    }
    history.push(url);
  }

  return (
    <Row>
      <Col xs="12">
        <div className="email-rightbar mb-3">
          <Card>
            <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
              <div id={"sc-body"} style={{maxHeight: 660}} className="table-responsive">
                <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                  <thead className="chart-thead">
                    <tr>
                      <th scope="col" >No</th>
                      <th scope="col" >계약명</th>
                      <th scope="col" >위탁 업체명</th>
                      <th scope="col" >수탁 업체명</th>
                      <th scope="col" >계약기간</th>
                      <th scope="col" >계약일자</th>
                    </tr>
                  </thead>
                  <tbody className="chart-tbody clickable">

                    {dataList && dataList.map((item, index) => {
                      return (
                        <tr key={item.id + '_' + index} onClick={() => { clickList(item) }}>
                          <td>{item.id}</td>
                          <td>{item.subject}</td>
                          <td>{item.company_from.name}</td>
                          <td>{item.company_to.name}</td>
                          <td>{item.start_date.substr(0, 10)} ~ {item.end_date.substr(0, 10)}</td>
                          <td>{item.updated_at.substr(0, 10)}</td>
                        </tr>
                      )
                    })
                    }
                    {dataList.length === 0 &&
                      <tr >
                        <td scope="row" colSpan="10">데이터가 없습니다.</td>
                      </tr>
                    }

                  </tbody>
                </table>
              </div>
            </CardBody>
            {isLoading && <Loading />}
          </Card>
        </div>
      </Col>
    </Row>
  )
}

export default OutsourcingUncontracted
